import { t } from "@/i18n";

export const defaultSaveModalConfig = () => ({
    title: t("shared.unsaved_changes.title"),
    description: t("shared.unsaved_changes.details"),
    ctaLabel: t("shared.unsaved_changes.action_save"),
    cancelLabel: t("shared.unsaved_changes.action_drop"),
    size: "xl",
    showXButton: false,
});
